var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2315 9.57234C14.2494 8.18282 14.9956 6.86803 16.1794 6.14024C15.4326 5.07366 14.1817 4.39742 12.8803 4.3567C11.4923 4.211 10.1466 5.18729 9.43926 5.18729C8.71824 5.18729 7.62919 4.37117 6.45647 4.39529C4.92787 4.44468 3.50284 5.31376 2.75914 6.65015C1.1605 9.41796 2.35294 13.4857 3.88431 15.723C4.65049 16.8185 5.54593 18.0423 6.7176 17.9989C7.86414 17.9513 8.29236 17.2678 9.67634 17.2678C11.0475 17.2678 11.4492 17.9989 12.6447 17.9713C13.875 17.9513 14.6501 16.8709 15.3894 15.765C15.9399 14.9844 16.3635 14.1216 16.6445 13.2087C15.1987 12.5972 14.2332 11.1422 14.2315 9.57234Z",
    fill: "#20272B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9735 2.88535C12.6443 2.08007 12.9748 1.04502 12.8947 0C11.8699 0.10764 10.9232 0.59745 10.2434 1.37184C9.57853 2.12845 9.23255 3.14529 9.29796 4.15037C10.3232 4.16092 11.3311 3.68439 11.9735 2.88535Z",
    fill: "#20272B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/apple_logo.f5fc7091801894fa8d113c3499ff2256.svg";
export { ForwardRef as ReactComponent };